import axios from 'axios';

// Shared between AnalyticsResultsFindingsView and AnalyticsFindingEvidenceChart so the
// master chart and the per-metric evidence charts stay visually and behaviorally in sync.
export const METER_LINE_COLOR = '#3d81f7';
export const CHART_MAX_POINTS = 600;
export const ANALYTICS_LOOKBACK_DAYS = 90;

export const DRIFT_TYPES = new Set(['trend_shift', 'change_point']);
export const DRIFT_METRICS = new Set([
    'hybrid_trend_shift',
    'change_point_detection',
    'trend_detection',
    'sliding_window_trend',
]);

export function averageOfValues(values) {
    if (!values.length) {
        return 0;
    }
    return values.reduce((sum, v) => sum + v, 0) / values.length;
}

// Standard deviation of reading values — the "swing" both chart components use
// to compare recent variability against baseline.
export function estimateSwing(points) {
    if (points.length < 2) {
        return 0;
    }
    const values = points.map((p) => p.value);
    const mean = averageOfValues(values);
    const variance = values.reduce((sum, v) => sum + ((v - mean) ** 2), 0) / values.length;
    return Math.sqrt(variance);
}

export async function fetchMeterReadings(company, meterId, days = ANALYTICS_LOOKBACK_DAYS) {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - days);

    const response = await axios.get(
        `${company.buildCompanyApiInternalRoute('data-meter')}/${meterId}`,
        {
            params: {
                startDate: start.toISOString(),
                endDate: end.toISOString(),
            },
        },
    );

    const raw = Array.isArray(response.data?.data) ? response.data.data : [];
    const points = raw
        .filter((row) => row.value != null && Number.isFinite(Number(row.value)))
        .map((row) => ({
            date: Number(row.date),
            value: Number(row.value),
        }));

    return {
        points,
        units: raw.find((row) => row.units)?.units || '',
        min: response.data?.min,
        max: response.data?.max,
    };
}
